import React from "react";
import { Door, Key, Permission } from "./types";

interface PermissionTableProps {
  doors: Door[];
  keys: Key[];
  permission: Permission[];
  handlePermissionChange: (idKey: number, idDoor: number, allow: boolean) => void;
  backendUrl: string;
  hoverCell: { door: number; key: number } | null;
  onHoverCell: (cell: { door: number; key: number } | null) => void;
}

const PermissionTable: React.FC<PermissionTableProps> = ({
  doors,
  keys,
  permission,
  handlePermissionChange,
  backendUrl,
  hoverCell,
  onHoverCell,
}) => {
  return (
    <div className="permission-table" onPointerLeave={() => onHoverCell(null)}>
      {doors.map((door, doorIndex) => (
        <div key={doorIndex} className="permission-table-row">
          {keys.map((key, keyIndex) => (
            <div
              key={keyIndex}
              onClick={() => handlePermissionChange(key.id, door.id, true)}
              // Podświetlenie tylko myszką - na dotyku zostałoby "przyklejone"
              onPointerEnter={(e) => {
                if (e.pointerType === "mouse") onHoverCell({ door: doorIndex, key: keyIndex });
              }}
              className={`permission-table-column${
                hoverCell && (hoverCell.door === doorIndex || hoverCell.key === keyIndex)
                  ? " is-crosshair"
                  : ""
              }`}
            >
              {permission.some(
                (perm) => perm.idKey === key.id && perm.idDoor === door.id
              ) ? (
                <img
                  src={`${backendUrl}/img/X.svg`}
                  alt="X"
                  style={{ width: "26px", height: "26px" }}
                />
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PermissionTable;
